import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/developers'),
      component: () => import('../SettingsWrapper.vue'),
      children: [
        {
          path: '',
          name: 'settings_developers',
          component: () => import('./Index.vue'),
          meta: { permissions: ['administrator'] },
        },
      ],
    },
  ],
};
